module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('app-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('tabela-validados', {
    attrs: {
      "titulo": "Participantes - Trail",
      "lista": _vm.listaTrail
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Participantes Inscritos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6d5d716"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pub/ListaInscritos.vue
// module id = 271
// module chunks = 1